export default "__VITE_ASSET__DmQrzcnv__"